import React, { forwardRef } from 'react';
import i18n from 'i18next';
import { Tooltip as MUITooltip } from '@material-ui/core';
import type { TooltipProps } from '@material-ui/core/Tooltip';
import type { KlpStyled } from '../Theme';
import { useKlpStyles } from '../Theme/useKlpStyles';
import classNames from 'classnames';

interface IOwnProps {
    title?: string;
    translation?: string;
    translationOptions?: Record<string, unknown>;
    hideTooltip?: boolean;
}

const styles = {};

export type ITooltipProps = IOwnProps & KlpStyled & Omit<TooltipProps, 'title'>;

export const Tooltip = forwardRef<unknown, ITooltipProps>((props, ref) => {
    const {
        title,
        translation,
        translationOptions,
        hideTooltip,
        children,
        PopperProps,
    } = props;
    const classes = useKlpStyles(props, styles);

    if (hideTooltip) return <>{children}</>;

    return (
        <MUITooltip
            ref={ref}
            {...PopperProps}
            className={classNames(classes.klpStyles, PopperProps?.className)}
            title={
                translation
                    ? (i18n.t(translation, translationOptions) as string)
                    : title || ''
            }
        >
            <span>{children}</span>
        </MUITooltip>
    );
});

Tooltip.displayName = 'Tooltip';
